export class TourTrackingObserver {
  constructor(usageTracker) {
    this.hasStopped = false;
    this.prevStepId = 'start';
    this.prevTourId = null;

    this.observe = (newStepId, newTourId) => {
      if (this.hasStopped) {
        return;
      }

      if (newStepId === null || newTourId === null) {
        if (newStepId === newTourId && this.prevStepId && this.prevTourId) {
          this.usageTracker.trackTourClose(this.prevTourId, this.prevStepId);
        }

        return;
      }

      if (this.prevStepId === 'start') {
        this.usageTracker.trackTourStart(newTourId);
        this.usageTracker.trackTourViewStep(newTourId, newStepId);
      } else if (newStepId === 'done') {
        this.usageTracker.trackTourFinish(newTourId);
      } else if (this.prevStepId !== 'done' && newStepId !== this.prevStepId) {
        this.usageTracker.trackTourViewStep(newTourId, newStepId);
      }

      this.prevStepId = newStepId;
      this.prevTourId = newTourId;
    };

    this.stopObserve = () => {
      this.hasStopped = true;
    };

    this.usageTracker = usageTracker;
  }

}